const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20animated%20manga%20panel%20showcase%20with%20flowing%20cherry%20blossoms%20and%20a%20romantic%20couple%20scene%2C%20warm%20golden%20lighting%2C%20Korean%20webtoon%20aesthetic%2C%20artistic%20illustration%20display&width=800&height=500&seq=media-manga-01&orientation=landscape',
    title: '恋爱幻想曲·名场面回顾',
    tag: '精选集锦',
    desc: '收集了本作最动人的十个告白场景，每一帧都值得反复回味。韩漫恋爱的天花板级表现。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20manga%20scene%20showcase%20with%20epic%20battle%20poses%20and%20magical%20effects%2C%20warm%20amber%20and%20gold%20lighting%2C%20Japanese%20shonen%20style%2C%20dramatic%20composition&width=800&height=500&seq=media-manga-02&orientation=landscape',
    title: '魔导纪元·战斗名场面合集',
    tag: '精选集锦',
    desc: '从初战到巅峰对决，主角成长之路上的每一场经典战役。日漫热血战斗的极致呈现。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20serene%20Chinese%20ink%20painting%20style%20landscape%20with%20floating%20mountains%20and%20clouds%2C%20traditional%20cultivation%20theme%2C%20warm%20sunset%20colors%2C%20elegant%20and%20peaceful%20atmosphere&width=800&height=500&seq=media-manga-03&orientation=landscape',
    title: '仙途无尽·场景美术欣赏',
    tag: '艺术赏析',
    desc: '国漫仙侠的场景设计堪称艺术品，每一处山水楼阁都蕴含东方美学精髓。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20popular%20manga%20covers%20displayed%20artistically%20on%20a%20gallery%20wall%2C%20warm%20gallery%20lighting%2C%20diverse%20genres%2C%20professional%20display&width=800&height=500&seq=media-manga-04&orientation=landscape',
    title: '本月新作推荐一览',
    tag: '编辑推荐',
    desc: '妖精漫画网编辑团队精选本月最值得追的新连载，奇幻恋爱悬疑全品类覆盖。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20reading%20nook%20with%20a%20tablet%20showing%20a%20colorful%20webtoon%2C%20warm%20lamp%20light%2C%20tea%20and%20blanket%2C%20comforting%20evening%20atmosphere%2C%20lifestyle%20photography&width=800&height=500&seq=media-manga-05&orientation=landscape',
    title: '妖精漫画网阅读体验指南',
    tag: '使用指南',
    desc: '从浏览到收藏，从追更到分享——妖精漫画网大全的完整使用攻略，助你畅享阅读。',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精彩推荐</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">妖精漫画网精选内容，发现更多不容错过的漫画精彩瞬间</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div key={item.title} className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 flex flex-col group cursor-pointer">
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={`${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-accent-500/90 text-background-50 text-[11px] font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-circle-fill text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-5 flex-1">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}